export default function Card6Icon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path d="m2.907 9.138 3.926 3.926c.762.766 1.567.771 2.33.01l3.94-3.941c.756-.762.756-1.567-.01-2.334L9.172 2.878c-.767-.767-1.572-.771-2.334-.01l-3.94 3.94c-.762.762-.757 1.568.01 2.33zm.835-.698c-.303-.308-.317-.62.005-.938l3.78-3.784c.322-.322.63-.313.937-.005l3.789 3.789c.308.308.317.62 0 .938l-3.784 3.784c-.323.317-.635.307-.938.005l-3.789-3.79zm.81-.25 3.228 3.228c.152.147.288.147.445-.005l3.222-3.222c.147-.147.147-.289-.005-.445L8.225 4.528c-.157-.156-.293-.156-.445-.004L4.558 7.746c-.157.156-.157.293-.005.445z" fill="#383A3D" fillRule="nonzero" />
      </g>
    </svg>
  );
};
